/* eslint-disable max-len */
import React from 'react';

export default function Quote(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.593 12.084v7.596H3.054v-1.97c0-3.075.225-5.363.675-6.864C4.217 9.31 5.473 7.134 7.5 4.32l3.207 1.8C9.018 9.01 8.043 10.997 7.78 12.084h2.813zm10.24 0v7.596h-7.539v-1.97c0-3.075.225-5.363.675-6.864.488-1.537 1.744-3.713 3.77-6.526l3.207 1.8c-1.688 2.889-2.663 4.877-2.926 5.964h2.813z"
        fill="#AB3A72"
      />
    </svg>
  );
}
